export var renderModalAnimation = function (_a) {
    var p = _a.p, e = _a.e, parent = _a.parent, overlay = _a.overlay, scroll = _a.scroll;
    if (parent) {
        parent.style.opacity = "".concat(p > 0 ? 1 : 0);
    }
    if (overlay) {
        overlay.style.opacity = "".concat(e);
    }
    if (scroll) {
        scroll.style.opacity = "".concat(e);
        scroll.style.transform = "translateY(".concat((1 - e) * 36, "px)");
    }
};
//# sourceMappingURL=utils.js.map